import React from "react";
import ApiService from "../../../services/ApiService";
import { Spinner } from "react-bootstrap";
import { store } from "../../../reducer/Store";
import TableDynamic from "../../../components/TableDynamic";
const DetailsCustomersList = ({ detailsCustomersList }) => {
  const { dispatch, state } = React.useContext(store);
  const columnsName = ["Code tiers", "Nom", "Groupement", "Statut"];
  const columns = ["id", "name", "group", "status"];
  const [noResultMessage, setNoResultMessage] = React.useState(false);

  /**
   * Cette fonction récupère les détails de tous les clients d'une liste de clients spécifique en fonction de la page et du nombre maximum de résultats par page spécifiés.
   * @param {Number} page - La page à récupérer (par défaut, la première page est récupérée).
   * @param {Number} max - Le nombre maximum de résultats par page à afficher (par défaut, il est défini à 25).
   */
  const getDetailsCustomersList = async (page = 1, max = 25) => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `customer-customer-list-customers/${detailsCustomersList.id}?page=${page}&max=${max}`,
      "get"
    )
      .then(function (response) {
        dispatch({ type: "SET_LOADER", payload: false });

        dispatch({
          type: "SET_PLANSTRADEDETAILSCUSTOMERSLIST",
          payload: response.data,
        });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        console.log(error);
        dispatch({ type: "SET_LOADER", payload: false });
      });
  };

  /**
   * Cette fonction effectue une recherche de clients en fonction d'un terme de recherche donné et d'une liste de clients spécifiée.
   * @param {String} search - Le terme de recherche à utiliser pour la recherche.
   * @param {Number} page - Le numéro de page pour la pagination de la recherche (par défaut : 1).
   * @param {Number} max - Le nombre maximum d'éléments par page pour la pagination de la recherche (par défaut : 25).
   */
  const searchCustomersByListId = (search, page = 1, max = 25) => {
    dispatch({ type: "SET_LOADER", payload: true });
    setNoResultMessage(false);
    ApiService.request(
      { customer_list_id: detailsCustomersList.id, search, page, max },
      "customer-list-customers-search-paginated",
      "post"
    )
      .then(function (response) {
        if (response.message === "No result.") {
          setNoResultMessage(true);
        } else {
          dispatch({
            type: "SET_PLANSTRADEDETAILSCUSTOMERSLIST",
            payload: response.data,
          });
        }
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        dispatch({ type: "SET_LOADER", payload: false });
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
        console.log(error);
      });
  };

  React.useEffect(() => {
    getDetailsCustomersList();
  }, [detailsCustomersList]);

  return (
    <>
      <div className="row mt-5">
        <div className="col-md-10">
          <h2 className="h1">{detailsCustomersList.name}</h2>
        </div>
      </div>
      {state.plansTradeDetailsCustomersList ? (
        <TableDynamic
          controlTableId="customers"
          columnsName={columnsName}
          columns={columns}
          data={state.plansTradeDetailsCustomersList.data}
          dataPagination={state.plansTradeDetailsCustomersList}
          getDataPagination={getDetailsCustomersList}
          search={searchCustomersByListId}
          setNoResultMessage={setNoResultMessage}
          noResultMessage={noResultMessage}
        />
      ) : (
        <div className="text-center">
          <Spinner
            animation={state.loader ? "border" : false}
            role="status"
          ></Spinner>
        </div>
      )}
    </>
  );
};

export default DetailsCustomersList;
